"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const WorkItem_1 = require("./WorkItem");
const react_1 = require("react");
const axios_1 = __importDefault(require("axios"));
const WorkList = ({ updateWorks, works }) => {
    const getWorks = () => {
        axios_1.default.get('api/works').then((res) => {
            updateWorks(res.data);
        });
    };
    (0, react_1.useEffect)(() => {
        getWorks();
    }, []);
    const displayWorks = () => {
        return ((0, jsx_runtime_1.jsx)("ul", Object.assign({ className: "workLists" }, { children: works.map((work) => ((0, jsx_runtime_1.jsx)(WorkItem_1.WorkItem, { work: work }, work.id))) })));
    };
    const displayNothings = () => {
        return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "nothing" }, { children: "\u691C\u7D22\u7D50\u679C\u304C\u3042\u308A\u307E\u305B\u3093" }));
    };
    console.log(works);
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: works.length ? displayWorks() : displayNothings() });
};
exports.WorkList = WorkList;
